// import 文を使って sub.js ファイルを読み込む。
import { backfaceFixed } from "./lib/backfaceFixed";
import { ua } from "./lib/userAgent";
import { vpFixed } from "./lib/viewportFixUnder360";
import objectFitImages from "object-fit-images";
import { swiper } from "./lib/swiper";

//初期化
// vpFixed();
objectFitImages();